(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/play.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/play.js');
"use strict";


const _ReactRouterDOM = ReactRouterDOM,
  withRouter = _ReactRouterDOM.withRouter;
const _ReactRedux = ReactRedux,
  connect = _ReactRedux.connect;
const Trotting = svs.components.sport.sportTypes.SportTypes.Trotting;
const cdn = svs.core.config.data.svsconfig.cdn;
const Button = svs.ui.Button;
const _svs$challenge = svs.challenge,
  BetslipWrapper = _svs$challenge.BetslipWrapper,
  OverviewContainer = _svs$challenge.OverviewContainer,
  ContextMenu = _svs$challenge.ContextMenu,
  Actionbar = _svs$challenge.Actionbar,
  PayWager = _svs$challenge.PayWager,
  Coupon = _svs$challenge.Coupon;
const _React = React,
  useRef = _React.useRef,
  useCallback = _React.useCallback;
const DrawSelector = svs.sport.DrawSelector;
const CampaignFlerp = svs.components.lbUi.campaignFlerp.CampaignFlerp;
const isMobile = svs.core.detect.formfactor.mobile();
const Play = _ref => {
  var _svs, _svs2;
  let settings = _ref.settings,
    updateMultipSwiper = _ref.updateMultipSwiper,
    selectedDraw = _ref.selectedDraw,
    selectedCoupon = _ref.selectedCoupon,
    selectAlternative = _ref.selectAlternative,
    draws = _ref.draws,
    history = _ref.history,
    currentDrawNumber = _ref.currentDrawNumber,
    selectedEventNumber = _ref.selectedEventNumber,
    isNFL = _ref.isNFL,
    clearCoupon = _ref.clearCoupon;
  let trottingText = 'Övr - övriga hästar i loppet';
  if (svs.challenge.data.config.specialTrottingEvent && svs.challenge.data.config.specialTrottingEvent.drawNumber === selectedDraw.drawNumber) {
    var _svs$challenge$data$c;
    selectedDraw.sport.type = Trotting;
    trottingText = ((_svs$challenge$data$c = svs.challenge.data.config.specialTrottingEvent) === null || _svs$challenge$data$c === void 0 ? void 0 : _svs$challenge$data$c.drawText) || 'Krysstexten ska vara X = Dött lopp eller ingen av hästarna är prisplacerad (Topp 7)';
  }
  const confirmClearCoupon = React.useCallback(() => {
    const dialog = new svs.components.dialog.Confirm({
      actions: [{
        title: 'Avbryt'
      }, {
        callback: () => {
          clearCoupon(currentDrawNumber);
          dialog.close();
        },
        title: 'Fortsätt'
      }],
      branding: svs.components.dialog.branding.SPORT,
      icon: 'dustbin',
      title: 'Vill du rensa dina tecken?'
    });
    svs.components.dialog.api.add(dialog);
  }, [clearCoupon, currentDrawNumber]);
  const scrollRef = useRef();
  const getScrollContainer = useCallback(() => svs.core.detect.formfactor.mobile() ? scrollRef.current.querySelector('.js-swiper-container') : scrollRef.current, []);
  const isTrotting = selectedDraw && selectedDraw.sport && selectedDraw.sport.type === Trotting;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "modal-sticky",
    id: "modal-sticky"
  }), React.createElement("div", {
    className: "lb-modal-hidden-content"
  }, React.createElement(OverviewContainer, null), React.createElement("div", {
    className: "game-column-content"
  }, React.createElement(DrawSelector, {
    branding: "challenge",
    drawNumber: currentDrawNumber,
    draws: draws,
    onToggle: updateMultipSwiper,
    selectDraw: drawNumber => {
      history.push("/spela/".concat(drawNumber));
    }
  }), svs.core.detect.formfactor.mobile() && React.createElement(CampaignFlerp, {
    branding: "challenge",
    isLightMode: true
  }), React.createElement("div", {
    className: "challenge-coupon-holder",
    id: "coupon-holder",
    ref: scrollRef
  }, React.createElement(ContextMenu, {
    drawNumber: currentDrawNumber
  }), React.createElement("div", {
    className: "trotting-coupon".concat(!isTrotting ? ' hide' : '')
  }, React.createElement("div", {
    className: "trotting-coupon-text"
  }, trottingText)), React.createElement(Actionbar, {
    currentCoupon: selectedCoupon,
    hasActionbar: selectedCoupon.hasActionbar,
    selectedXpert: selectedCoupon.xperten.selectedXpert
  }), React.createElement("div", {
    className: "padding-xs-h padding-xs-v-1 bg-white"
  }, React.createElement("span", {
    className: "f-bold align-middle"
  }, "V\xE4lj minst ett resultat i varje spelobjekt"), React.createElement("div", {
    className: "align-middle padding-xs-top-1"
  }, isTrotting ? (_svs = svs) === null || _svs === void 0 || (_svs = _svs.challenge) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.helpTexts) === null || _svs === void 0 || (_svs = _svs.startpage_mark_trotting) === null || _svs === void 0 ? void 0 : _svs.body : (_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.challenge) === null || _svs2 === void 0 || (_svs2 = _svs2.data) === null || _svs2 === void 0 || (_svs2 = _svs2.config) === null || _svs2 === void 0 || (_svs2 = _svs2.helpTexts) === null || _svs2 === void 0 || (_svs2 = _svs2.startpage_mark) === null || _svs2 === void 0 ? void 0 : _svs2.body)), React.createElement(Coupon, {
    coupon: selectedCoupon,
    draw: selectedDraw,
    history: history,
    selectedEventNumber: selectedEventNumber,
    selectItemAction: selectAlternative,
    settings: settings
  }), React.createElement("div", {
    className: "grid-row ".concat(!isNFL ? 'hide' : '')
  }, React.createElement("div", {
    className: "col-xs-4 col-xs-offset-4"
  }, React.createElement("img", {
    alt: "NFL Logotype",
    className: "block padding-v-1",
    src: "".concat(cdn, "/images/challenge/nfl-logotype.png")
  }))), React.createElement("div", {
    className: "padding-1"
  }, React.createElement(Button, {
    className: "qa-clear",
    onClick: confirmClearCoupon,
    size: 100,
    transparent: true
  }, "Rensa")), !isMobile && React.createElement(React.Fragment, null, React.createElement(PayWager, null), React.createElement(BetslipWrapper, {
    getScrollContainer: getScrollContainer
  }))))), isMobile && React.createElement(React.Fragment, null, React.createElement(PayWager, null), React.createElement(BetslipWrapper, {
    getScrollContainer: getScrollContainer
  })));
};
const mapStateToProps = (state, _ref2) => {
  let match = _ref2.match;
  const paramDrawNumber = Number(match.params.drawNumber);
  const eventNumber = Number(match.params.eventNumber);
  const selectedDraw = state.draws.find(_ref3 => {
    let drawNumber = _ref3.drawNumber;
    return drawNumber === paramDrawNumber;
  });
  let selectedCoupon;
  if (selectedDraw) {
    selectedCoupon = state.coupons.find(_ref4 => {
      let drawNumber = _ref4.drawNumber;
      return drawNumber === paramDrawNumber;
    });
  }
  let isNFL = false;
  for (let i = 0; i < selectedDraw.drawEvents.length; ++i) {
    if (selectedDraw.drawEvents[i].match && selectedDraw.drawEvents[i].match.league && selectedDraw.drawEvents[i].match.league.uniqueLeagueName === 'NFL') {
      isNFL = true;
      break;
    }
  }
  return {
    currentDrawNumber: paramDrawNumber,
    draws: state.draws,
    isNFL,
    selectedCoupon,
    selectedDraw,
    selectedEventNumber: eventNumber,
    settings: state.settings
  };
};
const _svs$challenge$action = svs.challenge.actions,
  selectAlternative = _svs$challenge$action.selectAlternative,
  clearCoupon = _svs$challenge$action.clearCoupon;
setGlobal('svs.challenge.Play', withRouter(connect(mapStateToProps, {
  clearCoupon,
  selectAlternative
})(Play)));

 })(window);